import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import LoadingOverlay from "../../components/LoadingOverlay";
import { T2 } from "../../styles/titles";
import Filter from "./components/filter";
import ConfigurationsTable from "./components/table";
import ConfigurationModal from "./components/configurationModal";
import NpsService from "./service/npsService";
import {
  NpsConfiguration,
  NpsConfigurationFilter,
  NpsConfigurationPayload,
} from "./types";
import { Container } from "./styles";

const PesquisaNps: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [configurations, setConfigurations] = useState<NpsConfiguration[]>([]);
  const [filter, setFilter] = useState<NpsConfigurationFilter>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedConfiguration, setSelectedConfiguration] =
    useState<NpsConfiguration | null>(null);
  const npsService = useMemo(() => new NpsService(), []);

  const fetchConfigurations = async () => {
    setIsLoading(true);

    try {
      setConfigurations(await npsService.getConfigurations(filter));
    } catch {
      toast.error("Erro ao buscar as pesquisas NPS.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigurations();
  }, [filter]);

  const openModal = (configuration: NpsConfiguration | null) => {
    setSelectedConfiguration(configuration);
    setIsModalOpen(true);
  };

  const handleSubmit = async (payload: NpsConfigurationPayload) => {
    if (selectedConfiguration) {
      await npsService.updateConfiguration(selectedConfiguration.id, payload);
    } else {
      await npsService.createConfiguration(payload);
    }

    toast.success(
      `Pesquisa NPS ${selectedConfiguration ? "atualizada" : "criada"} com sucesso!`
    );
    setIsModalOpen(false);
    await fetchConfigurations();
  };

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />
      <T2 style={{ marginBottom: 0 }}>Pesquisa NPS</T2>

      <Filter onFilter={setFilter} onCreate={() => openModal(null)} />
      <ConfigurationsTable records={configurations} onEdit={openModal} />

      <ConfigurationModal
        open={isModalOpen}
        configuration={selectedConfiguration}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
      />
    </Container>
  );
};

export default PesquisaNps;
